// @flow
import * as React from 'react';
import classNames from 'classnames/bind';
import cs from './styles.pcss';
import Icon from '../../../basic-components/icon';
import Tooltip from '../tooltip';

import type { Products_products_nodes_listings_problems as ProblemT } from '../../../typings/product-query.flow';

const cx = classNames.bind(cs);

type Props = {
  onClick: () => void,
  uncritical: boolean,
  problems: ProblemT[],
};

function Problem({ onClick, uncritical, problems }: Props): React.Node {
  let name = uncritical ? 'exclamation' : 'exclamationCircle';
  let tooltipTextId = `problem${uncritical ? 'Uncritical' : 'Critical'}`;
  let size = 16;

  const isHasError = problems.some((p) => p.severity === 'error');
  if (!isHasError) {
    name = 'standardErrorInfo';
    size = 21;
    tooltipTextId = 'problemStandardErrorInfo';
  }

  if (name === 'exclamation') {
    size = 17;
  }

  return (
    <Tooltip id={tooltipTextId}>
      <button
        type="button"
        onClick={onClick}
        className={cx('problem', { uncritical })}
      >
        <Icon name={name} size={size} className={cx('icon')} />
      </button>
    </Tooltip>
  );
}

export default Problem;
